// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #f4f4f4;
}

.main-content {
  flex: 1 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.question-window {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 80%;
  max-width: 800px;
  padding: 30px;
}

.question-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #2c3e50;
}

.country-selection {
  margin-bottom: 20px;
}

.select-label {
  display: block;
  margin-bottom: 8px;
  color: #7f8c8d;
}

.select-dropdown {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  margin-bottom: 15px;
}

.topic-selection {
  margin-bottom: 20px;
}

.message-input {
  width: 100%;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  min-height: 120px;
  margin-bottom: 20px;
  resize: vertical;
}

.enter-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  float: right;
}

.enter-button:hover {
  background-color: #2980b9;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".page-container {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  background-color: #f4f4f4;\n}\n\n.main-content {\n  flex: 1;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.question-window {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 80%;\n  max-width: 800px;\n  padding: 30px;\n}\n\n.question-title {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.country-selection {\n  margin-bottom: 20px;\n}\n\n.select-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #7f8c8d;\n}\n\n.select-dropdown {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n\n.topic-selection {\n  margin-bottom: 20px;\n}\n\n.message-input {\n  width: 100%;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n  min-height: 120px;\n  margin-bottom: 20px;\n  resize: vertical;\n}\n\n.enter-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  float: right;\n}\n\n.enter-button:hover {\n  background-color: #2980b9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
